// // 一些常用工具封装
// 一些常用工具封装

export function formatDate(date: any, fmt: string) {
    if (!date) return date;

    date = new Date(date);
    const o: any = {
        'M+': date.getMonth() + 1, //月份
        'd+': date.getDate(), //日
        'h+': date.getHours(), //小时
        'm+': date.getMinutes(), //分
        's+': date.getSeconds(), //秒
        'q+': Math.floor((date.getMonth() + 3) / 3), //季度
        S: date.getMilliseconds(), //毫秒
    };

    if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
    for (const k in o)
        if (new RegExp('(' + k + ')').test(fmt))
            fmt = fmt.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
    return fmt;
}

export function offset(ele) {
    const obj = {
        x: ele.offsetLeft + parseInt(css(ele, 'border-left-width')),
        y: ele.offsetTop + parseInt(css(ele, 'border-top-width')),
    };
    let current = ele.offsetParent;
    while (current !== null) {
        obj.x += current.offsetLeft + parseInt(css(current, 'border-left-width'));
        obj.y += current.offsetTop + parseInt(css(current, 'border-top-width'));
        current = current.offsetParent;
    }
    return obj;
}

export function css(ele, attr) {
    return getComputedStyle(ele, null)[attr];
}

export function startMove(obj, json, times, fx, fn) {
    if (typeof times == 'undefined') {
        //缺times,fx,fn
        times = 400;
        fx = 'linear';
    }

    if (typeof times == 'string') {
        //缺times
        if (typeof fx == 'function') {
            fn = fx;
        }
        fx = times;
        times = 400;
    } else if (typeof times == 'function') {
        //缺times,fx
        fn = times;
        times = 400;
        fx = 'linear';
    } else if (typeof times == 'number') {
        if (typeof fx == 'function') {
            //缺fx
            fn = fx;
            fx = 'linear';
        } else if (typeof fx == 'undefined') {
            //缺fx,fn
            fx = 'linear';
        }
    }

    const iCur = {};

    for (const attr in json) {
        iCur[attr] = 0;

        if (attr == 'opacity') {
            iCur[attr] = Math.round(getStyle(obj, attr) * 100);
        } else if (attr === 'scrollTop') {
            const scrollTopDom = document.body || document.documentElement;
            iCur[attr] = Math.round(scrollTopDom.scrollTop);
        } else {
            iCur[attr] = parseInt(getStyle(obj, attr));
        }
    }

    const startTime = now();

    clearInterval(obj.timer);

    obj.timer = setInterval(function () {
        const changeTime = now();

        const t = times - Math.max(0, startTime - changeTime + times); //0到2000

        for (const attr in json) {
            const value = Tween[fx](t, iCur[attr], json[attr] - iCur[attr], times);

            if (attr == 'opacity') {
                obj.style.opacity = value / 100;
                obj.style.filter = 'alpha(opacity=' + value + ')';
            } else if (attr === 'scrollTop') {
                obj[attr] = value;
            } else {
                obj.style[attr] = value + 'px';
            }
        }

        if (t == times) {
            clearInterval(obj.timer);
            if (fn) {
                fn.call(obj);
            }
        }
    }, 13);

    function getStyle(obj, attr) {
        if (obj.currentStyle) {
            return obj.currentStyle[attr];
        } else {
            return getComputedStyle(obj, null)[attr];
        }
    }

    function now() {
        return new Date().getTime();
    }
}

const Tween = {
    linear: function (t, b, c, d) {
        //匀速
        return (c * t) / d + b;
    },
    easeIn: function (t, b, c, d) {
        //加速曲线
        return c * (t /= d) * t + b;
    },
    easeOut: function (t, b, c, d) {
        //减速曲线
        return -c * (t /= d) * (t - 2) + b;
    },
};

/**
 * 钱币加逗号分隔符
 * @param num 数字
 */
export function toThousands(num) {
    return (num || 0).toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
}